(function ($) {
  const $filters = $(".filters");
  const $filter_form = $("#filter");
  const $filter_input = $filters.find("input");
  const $video_grid = $(".video-grid");

  const $period_filters = $(".period-filter:not(.period-filter--all)");
  const $period_filter_all = $(".period-filter--all");
  const $load_more = $("#ajax-load-more");

  var ppp = 9; // Post per page
  var pageNumber = 1;

  $period_filters.on("change", function () {
    $period_filter_all.prop("disabled", false);
    $period_filter_all.removeAttr("checked");

    if ($(".period-filter:checked").length < 1) {
      $period_filter_all.prop("checked", true);
      $period_filter_all.prop("disabled", true);
    }
  });

  $period_filter_all.on("change", function () {
    if ($(this).is(":checked")) {
      $period_filters.prop("checked", false);
      $(this).prop("disabled", true);
    }
  });

  $filters.on("submit", function (e) {
    e.preventDefault();
    ajaxFilter($(this));
  });

  $filter_input.change(function (e) {
    var form = $(this).closest("form");
    pageNumber = 1;
    ajaxFilter(form);
  });

  $(window).on("load", function () {
    ajaxFilter($filter_form);
  });

  function ajaxFilter(form) {
    var form_data = form.serialize();

    $.ajax({
      url: wpAjax.ajaxUrl,
      data: {
        action: "filter_videos",
        data: form_data,
      },
      type: "POST",
      beforeSend: function () {
        $video_grid.html('<div class="pre-loader"><span></span></div>');
      },
      success: function (response) {
        removePostsCount();
        $video_grid.html(response);
        updateLoadMoreButton();
      },
      error: function (response) {
        console.warn(response);
      },
    });
    return false;
  }

  $load_more.on("click", function () {
    var button_display = $(this).css("display");
    var filters;
    if (button_display == "flex") {
      filters = $("#filter");
    } else {
      filters = $("#filter-mobile");
    }

    var filters_data = filters.serialize();
    loadMore(filters_data);
  });

  function loadMore(filters) {
    pageNumber++;
    var str = filters + "&pageNumber=" + pageNumber + "&ppp=" + ppp;
    $.ajax({
      type: "POST",
      dataType: "html",
      url: wpAjax.ajaxUrl,
      data: {
        action: "filter_videos",
        data: str,
      },
      success: function (data) {
        removePostsCount();
        console.log(str);
        var $data = $(data);
        if ($data.length) {
          $video_grid.append($data);
        }
        updateLoadMoreButton();
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log(jqXHR + " :: " + textStatus + " :: " + errorThrown);
      },
    });
    return false;
  }

  function updateLoadMoreButton() {
    var posts_found = $("#posts-found");
    if (posts_found.length) {
      var num_of_posts = posts_found.text();
      if (num_of_posts <= 0) {
        $load_more.addClass("hidden");
      } else {
        $load_more.removeClass("hidden");
      }
    } else {
      return;
    }
  }

  function removePostsCount() {
    var posts_found = $("#posts-found");
    if (posts_found.length) {
      posts_found.remove();
    }
  }
})(jQuery);
